import type { ButtonHTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/utils";
import { Icon, type IconName } from "./icon";

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  name: IconName;
  label: string;
  active?: boolean;
  size?: number;
  badge?: ReactNode;
}

export function IconButton({
  name,
  label,
  active,
  size = 18,
  badge,
  className,
  type = "button",
  ...props
}: IconButtonProps) {
  return (
    <button
      type={type}
      aria-label={label}
      title={label}
      className={cn("icon-btn", active && "active", className)}
      {...props}
    >
      <Icon name={name} size={size} />
      {badge ? <span className="icon-badge">{badge}</span> : null}
    </button>
  );
}
